import { useUpdateScreenChatContext } from '$tablet-app/src/app/chat/hooks';
import { RootStackScreenProps } from '$tablet-app/src/app/navigation/RootStackNavigator/RootStackNavigator';
import { useCurrentProfile } from '$tablet-app/src/app/users';
import { PhoneTypes } from '@akin-home/contacts';
import {
  useGetContactQuery,
  useUpdateContactMutation,
} from '@akin-home/contacts/react';
import { showSuccessToast } from '@akin-home/toast/native';
import { createRoom } from '@akin-home/video-call/frontend';
import {
  CreateVideoCallScreen,
  CreateVideoCallScreenOnSend,
} from './CreateVideoCallScreen';

export const CreateVideoCallScreenWrapper = (
  props: RootStackScreenProps<'CreateVideoCall'>
) => {
  const {
    navigation: { goBack, replace },
    route: {
      params: { contact_id },
    },
  } = props;

  useUpdateScreenChatContext();

  const { profile } = useCurrentProfile();

  const { data: contact } = useGetContactQuery(contact_id);
  const update = useUpdateContactMutation();

  const onSend = async (data: CreateVideoCallScreenOnSend) => {
    if (!contact)
      return { error: { code: 'no_contact', message: 'No Contact Set' } };

    const create_room_params: Parameters<typeof createRoom>[0] = {
      to_name: contact?.name,
      from_name: profile.name,
      invitation_body: data.invitation_body,
    };

    if (data.mode === 'email') {
      if (!data.email)
        return { error: { code: 'no_email', message: 'No email specifed' } };
      create_room_params.to_email = data.email;
      create_room_params.from_email = profile.email;
    }

    if (data.mode === 'sms') {
      if (!data.phone_number)
        return {
          error: { code: 'no_phone', message: 'No phone number specified' },
        };
      create_room_params.to_phone = data.phone_number;
    }

    /** Do the actual sending */
    const res = await createRoom(create_room_params);

    /** On result, get room code and navigate to video call screen */
    if (res.success) {
      showSuccessToast({ text1: 'Invitation sent!' });

      replace('VideoCall', { url: res.data.url });

      if (data.mode === 'email' && data.save_email_to_contact && data.email) {
        update.mutate({
          input: {
            id: contact?.id,
            emailAddresses: [...(contact.emailAddresses || []), data.email],
          },
        });
      }

      if (
        data.mode === 'sms' &&
        data.save_phone_number_to_contact &&
        data.phone_number
      ) {
        update.mutate({
          input: {
            id: contact?.id,
            phoneNumbers: [
              ...(contact.phoneNumbers || []),
              { type: PhoneTypes.Mobile, number: data.phone_number },
            ],
          },
        });
      }

      return { success: true };
    }

    return {
      success: false,
      error: { code: 'server', message: res.error },
    };
  };

  return (
    <CreateVideoCallScreen
      contact={contact}
      onSend={onSend}
      onCancel={goBack}
    />
  );
};
